import SettingsContainer from './SettingsContainer';

/*
* 문제 화면
*/
export default SettingsContainer;